/* Connect native Shopify product/cart events to the same storefront bag. */
import {CartLinesUpdateEvent,StandardEvents} from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
 if(event.dollopShared)return;
 // The native drawer can otherwise open alongside the shared bag on product add.
 document.querySelectorAll('cart-drawer-component[auto-open]').forEach(el=>el.removeAttribute('auto-open'));
 const source=event.target instanceof Element?event.target:null;
 const sourceModal=source?.closest('dialog:modal');
 const trigger=source?.querySelector('[type="submit"]')||document.querySelector('.dc-header [data-open-bag]');
 event.promise?.then(({cart,detail})=>{
  if(detail?.didError)return;
  window.dollopCart?.syncCount(cart?.totalQuantity||0);
  if(event.action!=='add'){window.dollopCart?.refresh();return}
  const show=()=>window.dollopCart?.open(trigger);
  if(sourceModal?.open)sourceModal.addEventListener('close',show,{once:true});else show();
 }).catch(()=>{}); // Native product forms retain their own error message and retry.
},true);

document.addEventListener('dollop:cart-changed',event=>{
 const data=event.detail.cart;
 const update=new CartLinesUpdateEvent({
  action:'update',context:'cart',
  lines:data.items.map(item=>({id:item.key,quantity:item.quantity})),
  promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(data),detail:{source:'dollop-shared-bag',items:data.items,itemCount:data.item_count,didError:false}})
 });
 update.dollopShared=true;
 document.dispatchEvent(update);
});
